import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ItemFilterView from 'components/items/ItemFilterView';
import * as itemsActions from 'store/modules/items';

class ItemFilterContainer extends Component {

  componentDidMount() {
    const {itemFilters} = this.props;
    const {itemKind} = itemFilters;
    
    this.getItemList(itemKind);
  }

  getItemList = async (id) => {
    const {ItemsActions, itemList} = this.props;
    const childItemList = itemList['list'+id];
    
    try {
      if(!childItemList.length > 0) {
        await ItemsActions.getItemList(id);
      }
    }catch(e){
      console.log(e);
    }
  }

  onChangeItemKind = (e) => {
    const {name, value} = e.target;
    const {ItemsActions} = this.props;

    ItemsActions.setItemsFilter({name, value});
    this.getItemList(value);
  }

  onChangeItemFilter = (e) => {
    const {alt, name, value, checked} = e.target;
    const {ItemsActions} = this.props;

    ItemsActions.setItemsFilterDtl({alt, name, value, checked});
  }

  onChangeTextFilter = (e) => {
    const {value} = e.target;
    const {ItemsActions} = this.props;

    ItemsActions.setItemsFilterText({value});
  }

  onClickFilterInit = () => {
    const {ItemsActions} = this.props;
    ItemsActions.setFilterInit();
  }

  render() {
    const {onChangeItemKind, onChangeItemFilter, onChangeTextFilter, onClickFilterInit} = this;
    const {itemFilters} = this.props;
    
    return (
      <ItemFilterView 
        onChangeItemKind={onChangeItemKind} 
        onChangeItemFilter={onChangeItemFilter}
        onChangeTextFilter={onChangeTextFilter}
        onClickFilterInit={onClickFilterInit}
        itemFilters={itemFilters}
      />
    );
  }
}

export default connect(
  (state) => ({
    itemFilters: state.items.toJS().itemFilters,
    itemList: state.items.toJS().itemList,
    // weaponWhere: state.weapon.toJS().weaponWhere,
    // weapons: state.weapon.toJS().weapons,
    // loading: state.pender.pending['weapon/GET_WEAPON_LIST']
  }),
  (dispatch) => ({
    ItemsActions: bindActionCreators(itemsActions, dispatch)
  })
)(ItemFilterContainer);